<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <div>
              <strong>状態を変更する回線を選択してください。</strong>
              <div class="mt-3">
                <v-table density="compact">
                  <thead class="v-table-head">
                    <tr>
                      <th class="th-check"></th>
                      <th class="th-wnumber">VNコネクト番号</th>
                      <th class="th-act-sby">Act/Sby</th>
                      <th class="th-enable">変更後の状態</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(e, i) in vnConnects" :key="i">
                      <tr
                        v-if="e.cloudVnConnectAct.isVnConnectStatus !== enable"
                      >
                        <td>
                          <v-checkbox-btn
                            :value="e.cloudVnConnectAct.wnumber"
                            v-model="selected"
                            @click.stop
                          />
                        </td>
                        <td>{{ e.cloudVnConnectAct.wnumber }}</td>
                        <td>Act</td>
                        <td>{{ enable ? "有効" : "無効" }}</td>
                      </tr>
                      <tr
                        v-if="
                          e.cloudVnConnectSby &&
                          e.cloudVnConnectSby.isVnConnectStatus !== enable
                        "
                      >
                        <td>
                          <v-checkbox-btn
                            :value="e.cloudVnConnectSby.wnumber"
                            v-model="selected"
                            @click.stop
                          />
                        </td>
                        <td>{{ e.cloudVnConnectSby.wnumber }}</td>
                        <td>Sby</td>
                        <td>{{ enable ? "有効" : "無効" }}</td>
                      </tr>
                    </template>
                  </tbody>
                </v-table>
              </div>
            </div>
          </v-container>
        </div>
        <v-alert v-if="alertMsg" class="my-4" :text="alertMsg"></v-alert>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "MultiCloudVNConnectStatusModify",
  props: {
    /** true: 変更後の状態が有効, false: 変更後の状態が無効 */
    enable: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    /** 状態変更対象の回線一覧 */
    vnConnects: {
      type: Array as PropType<
        {
          cloudVnConnectAct: {
            wnumber: string;
            isVnConnectStatus: boolean;
          };
          cloudVnConnectSby?: {
            wnumber: string;
            isVnConnectStatus: boolean;
          };
        }[]
      >,
      required: true,
    },
  },
  data() {
    return {
      // 変更できるレコードのみチェックをつける
      selected: this.vnConnects
        .flatMap((e) => {
          return e.cloudVnConnectSby
            ? [e.cloudVnConnectAct, e.cloudVnConnectSby]
            : [e.cloudVnConnectAct];
        })
        .filter((e) => e.isVnConnectStatus !== this.enable)
        .map((e) => e.wnumber),
      alertMsg: null as null | string,
    };
  },
  methods: {
    ok() {
      if (this.selected.length === 0) {
        this.alertMsg = this.$filter.message("no_select_data");
        return;
      } else {
        this.alertMsg = null;
      }

      (
        this.$refs.modal as typeof VueFinalModal & { ok: (r: unknown) => void }
      ).ok(this.selected);
    },
  },
});
</script>

<style scoped lang="scss">
.th-check {
  width: 50px;
}
.th-act-sby,
.th-enable {
  width: 150px;
}
</style>
